import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App';
import './i18n/config';
import './index.css';

// Brand fonts (vendored — no CDN per platform residency rules).
// Inter for Latin body, Source Serif 4 for headings, Noto Naskh Arabic for AR
// surfaces, JetBrains Mono for IDs/codes. Each font ships a subset of weights
// that the theme actually uses.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/source-serif-4/400.css';
import '@fontsource/source-serif-4/600.css';
import '@fontsource/source-serif-4/700.css';
import '@fontsource/noto-naskh-arabic/400.css';
import '@fontsource/noto-naskh-arabic/500.css';
import '@fontsource/noto-naskh-arabic/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import { setupAxiosAuth } from './lib/axiosAuth';

setupAxiosAuth();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 300000, gcTime: 300000, retry: 1, refetchOnWindowFocus: false, refetchOnReconnect: true, refetchOnMount: true },
    mutations: { retry: 0 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </QueryClientProvider>
  </React.StrictMode>,
);
